export enum RacaCorEnum {
    Branca = 1,
    Preta = 2,
    Parda = 3,
    Amarela = 4,
    Indigena = 5,
    NãoInformado = 6
  }